module.exports = __webpack_public_path__ + "fonts/FSSinclair-Medium.e666d5d4.otf";